import { environment } from '@environments/environment';
import { ElasticSearchQueryInput } from '@services/elastic-search/models';

export const GET_STORE_PROMOTION_QUERY = (storeUuid: string): ElasticSearchQueryInput => ({
  query: '_search',
  index: environment.integrations?.fournierWebservice?.index_store ?? '',
  body: {
    size: 1,
    _source: ['promotion'],
    query: {
      bool: {
        filter: [
          {
            term: {
              search_api_datasource: 'entity:node',
            },
          },
          {
            term: {
              uuid: storeUuid,
            },
          },
        ],
      },
    },
  },
});
